import React, { Component } from 'react';
import { Session, NavBar, CarouselDashboard, Slider, Footer, MenuCategories, ItemsList, ItemSlider, ItemSliderResponsive, Suscription, TopNavBar, CarouselTrademarks, DejanosMensajeModal,ItemSlider1,ItemSlider2, } from '../../components';
import { config, VIEW_NAME, SERVICE_API, DISPATCH_ID, ROLES  } from '../../libs/utils/Const';
import { connect } from "react-redux";
import { Prueba } from '../../components/MenuCategories';
import { ApiClient } from "../../libs/apiClient/ApiClient";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import './Categories.css';
import $ from "jquery";

const apiClient = ApiClient.getInstance();
class DashboardViewBuild extends Component {
 
    render() {   
        return (
            <div className="container-fluid" style={{ marginTop: 0, backgroundColor: "#FFFFFF", paddingLeft:0, paddingRight:0 }}>
               <img src={config.buildPage.img} width="100%" />
            </div >
        );
    }
}

const mapStateToProps = store => {
    return {
        itemsReducer: store.ItemsReducer,
        sessionReducer: store.SessionReducer,
        configReducer: store.ConfigReducer
    };
};


const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value }),
        setItemsSearch: value => dispatch({ type: DISPATCH_ID.ITEMS_SET_ITEMS, value }),
        setItemsFilterSearch: value => dispatch({ type: DISPATCH_ID.ITEMS_SAVE_ITEMS_FILTER, value }),
        setTotalRows : value => dispatch({type: DISPATCH_ID.ITEMS_SET_TOTALROWS, value}),
        setItemsCategories: value => dispatch({type: DISPATCH_ID.ITEMS_SET_CATEGORIES, value}), 
        setLocation:  value => dispatch({type: DISPATCH_ID.ITEMS_SET_LOCATION, value}),
        setDashboard:  value => dispatch({type: DISPATCH_ID.ITEMS_SET_DASH, value}),
        searchByDash:  value => dispatch({type: DISPATCH_ID.ITEMS_SET_SEARCH_BY_DASH, value}),
        searchByDashOption: value => dispatch({type: DISPATCH_ID.ITEMS_SET_SEARCH_BY_DASH_OPTION, value}),
        setCategory: value => dispatch({type: DISPATCH_ID.ITEMS_SET_CATEGORY, value}),
        setIdCategory: value => dispatch({type: DISPATCH_ID.ITEMS_SET_IDCATEGORY, value}),
        setNextPage:  value => dispatch({type: DISPATCH_ID.ITEMS_SET_NEXTPAGE, value}),
    };
};
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DashboardViewBuild);